import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges,} from '@angular/core';
import {CommmCode} from 'src/app/utils/constante/CommonCode';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Certificat, InfoOs} from 'src/app/domain';
import {LoginService} from 'src/app/modules/services/user/login/login.service';
import {Platform} from '@angular/cdk/platform';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {MatDialog} from '@angular/material/dialog';
import {SelectionModel} from '@angular/cdk/collections';
import {CertificatDetailsComponent} from 'src/app/pages/auth/certificat-details/certificat-details.component';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {CertifFournisseurService} from 'src/app/modules/services/fournisseur/certif-four/certif-fournisseur.service';
import {CertifAchetService} from 'src/app/modules/services/acheteur/certif/certif-achet.service';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {Location} from '@angular/common';
import {DatenowService} from '../../../../../modules/services/datenow.service';
import {CustomValidators} from '../../../../../forms/validators';
import {AppTranslateService} from '../../../../../modules/services/translate/app-translate.service';

type Column = keyof Certificat | 'action';

@Component({
    selector: 'app-add-infog-certif',
    templateUrl: './add-infog-certif.component.html',
    styleUrls: ['./add-infog-certif.component.css'],
})
export class AddInfogCertifComponent implements OnInit {
    @Input() acheteur = false;
    disabled_conn: boolean = true;
    c = false;
    j = false;
    r = false;
    t = false;
    q = false;
    form: FormGroup;

    @Output() next = new EventEmitter<any>();
    data: any[];
    @Input() id;

    loading = {
        list: false,
    };

    CommmCode = CommmCode;
    currentDate: any;
    infoUser: any;
    onLoading: boolean = true;
    bizRegNo;
    disabled = false;
    DOWNLOAD_URL_BASE = 'https://www.tuneps.tn/localserver/';
    @Input() certificatees: Certificat[];
    dataSource = new MatTableDataSource<Certificat>();
    displayedColumns: Column[] = [
        'commonName',
        'issuerCommonName',
        'notAfter',
        'action',
    ];
    labels: Partial<Record<Column, string>> = {
        commonName: 'Utilisateur',
        issuerCommonName: 'Emetteur',
        notAfter: 'Date d\'expiration',
    };
    selection = new SelectionModel<Certificat>(false, []);
    @Input() ondelete: boolean;
    certificatdetails: Certificat[] = [];
    certificates: Certificat[] = [];
    infooscert: InfoOs;
    name: string;
    certiflocalbool: boolean = false;
    isAuthenticating = false;

    constructor(
        private formBuilder: FormBuilder,
        private loginService: LoginService,
        public platform: Platform,
        private dialog: MatDialog,
        private router: Router,
        private confirmdialog: ConfirmDialogService,
        private activatedRoute: ActivatedRoute,
        private certifAchetService: CertifAchetService,
        private certifFournisseurService: CertifFournisseurService,
        private toast: ToastService,
        private _location: Location,
        private datenowService: DatenowService,
        private appTranslateService: AppTranslateService
    ) {
    }

    get readColumns() {
        return this.displayedColumns.filter((column) => column !== 'action');
    }

    ngOnInit(): void {
        this.getCurrentDate();
        this.activatedRoute.params.subscribe((params) => {
            this.bizRegNo = params.bizRegNo;

            // console.log("ssss",this.movement)
        });
        this.getdetail();
        this.getAll();
        this.verifierLocal();
    }

    onSuccess() {
      
        this.selection.selected.forEach((row) => {
        this.name = row.commonName;
        });
        console.log('this.form. !!! ', this.form)
       
      
       
       
        this.loginService.getEncData(this.name).subscribe((encData) => {
            this.form.controls['encData'].setValue(encData);

            if (this.acheteur == false) {
                if (this.form.controls['j'].value == true) {
                    this.form.controls['authListStr'].setValue('j');
                } else {
                    this.form.controls['authListStr'].setValue('c');
                }
            } else {
                if (this.form.controls['h'].value == true) {
                    this.form.controls['authListStr'].setValue('h');
                } else {
                    this.form.controls['authListStr'].setValue('g');
                }
            }
            if (!this.acheteur) {
                this.isAuthenticating = true;
                this.loading.list = true;
                this.certifFournisseurService
                    .addCertifFourni(this.form.getRawValue())
                    .subscribe((res) => {
                        if (!['DUPL', 'NOT_IN_LIST_Mand', 'Already_Exist','INVALID-CERT','EXP-CERT','DONNEES_ERRON'].includes(res['payload'].errorMsg)) {
                            console.log(' t1 : ',res['payload'],'t2 : ',res['payload'].errorMsg)
                            this.loading.list = false;
                            this.toast.success('saved_successfully');
                            this.router.navigateByUrl('/portail/certif_fournisseur');
                        } else {
                            if(res['payload'].errorMsg== 'DUPL')
                            this.toast.error( 'Il existe un duplicatat de ce certificat.')
                            if(res['payload'].errorMsg== 'INST_CHECKED')
                            this.toast.error( 'Il existe un duplicat de ce certificat.')
                                if(res['payload'].errorMsg== 'NOT_IN_LIST_Mand')
                                this.toast.error( 'Personne inexistante dans la liste des mandataires.')
                                if(res['payload'].errorMsg=='Already_Exist')
                                this.toast.error( 'Personne déjà enregistrée.');
                                if(res['payload'].errorMsg=='INVALID-CERT')
                                this.toast.error( 'Certificat invalide.');
                                if(res['payload'].errorMsg== 'EXP-CERT')
                                this.toast.error('Le certificat est expiré ');
                                    if(res['payload'].errorMsg== 'DONNEES_ERRON')
                                    this.toast.error( 'Merci de vérifier vos données ');

                            this.loading.list = false;
                           
                        }
                    });
            } else {
               
                this.form.get('chfIndRegNo').clearValidators();
                 this.form.get('chfIndRegNo').updateValueAndValidity();
                if(this.form.valid){
                    this.isAuthenticating = true;
                    this.loading.list = true;
                    this.certifAchetService
                    .addCertifAch(this.form.getRawValue())
                    .subscribe((res) => {
                        if (!['DUPL', 'NOT_IN_LIST_Mand', 'Already_Exist','INVALID-CERT','EXP-CERT','DONNEES_ERRON'].includes(res['payload'].errorMsg)) {
                            this.loading.list = false;
                            this.toast.success('saved_successfully');
                            this.router.navigateByUrl('/portail/certif_acheteur');
                        } else {
                            if(res['payload'].errorMsg== 'DUPL')
                            this.toast.error( 'Il existe un duplicatat de ce certificat.')
                                if(res['payload'].errorMsg== 'NOT_IN_LIST_Mand')
                                this.toast.error( 'Personne inexistante dans la liste des mandataires.')
                                if(res['payload'].errorMsg=='Already_Exist')
                                this.toast.error( 'Personne déjà enregistrée.');
                                if(res['payload'].errorMsg=='INVALID-CERT')
                                this.toast.error( 'Certificat invalide.');
                                if(res['payload'].errorMsg== 'EXP-CERT')
                                this.toast.error('Le certificat est expiré ');
                                    if(res['payload'].errorMsg== 'DONNEES_ERRON')
                                    this.toast.error( 'Merci de vérifier vos données ');

                            this.loading.list = false;
                           
                        }
                    });
                }
                else {
                    this.form.markAllAsTouched();
                }
              
            }


        });
    

    }

    get(key: string) {
        return this.form?.get(key) as FormControl;
    }

    getCurrentDate() {
        this.datenowService.getdatenow().subscribe((curentdate) => {
            this.currentDate = curentdate;
        });
    }

    getdetail() {
        if (!this.acheteur) {
            this.certifFournisseurService
                .checkIdRegistre(this.bizRegNo)
                .subscribe((res) => {
                    this.infoUser = res['payload'];
                    if (res['payload'].success != 'N') {
                        this.certifFournisseurService
                            .checkListDroits(this.bizRegNo)
                            .subscribe((checklist) => {
                                if (checklist['payload'].authDuplYn == 'Y') {
                                    this.disabled = true;
                                    this.form = this.formBuilder.group({
                                        bizRegNo: this.formBuilder.control({
                                            value: res['payload'].bizRegNo,
                                            disabled: true,
                                        }),
                                        masterCd: this.formBuilder.control(res['payload'].bizRegNo),
                                        supplierNm: this.formBuilder.control({
                                            value: res['payload'].supplierNm.trim(),
                                            disabled: true,
                                        }),

                                        staffNm: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        encData: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        authListStr: this.formBuilder.control('c'),
                                        indRegNo: this.formBuilder.control(null, [
                                            Validators.required,
                                            this.infoUser ?
                                                this.infoUser.isTunisian == 'Y' ? CustomValidators.isCin() : CustomValidators.isPassport()
                                                : Validators.nullValidator, Validators.required
                                        ]),
                                        issuedYmdStr: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),

                                        staffDeptNm: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        positionNm: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        telNo: this.formBuilder.control(null, [
                                            Validators.required, CustomValidators.PhoneNumberValidator()
                                        ]),
                                        faxNo: this.formBuilder.control(null),
                                        mtelNo: this.formBuilder.control(null),
                                        email: this.formBuilder.control(null, [
                                            Validators.required,
                                            CustomValidators.emailValidator(),
                                        ]),
                                        corporationCl: this.formBuilder.control(
                                            res['payload'].corporationCl,
                                            [Validators.required]
                                        ),
                                        artisanNo: this.formBuilder.control(
                                            res['payload'].artisanNo,
                                            [Validators.required]
                                        ),
                                        chfIndRegNo: this.formBuilder.control(res['payload'].chfIndRegNo, [Validators.required]),
                                        regDt: this.formBuilder.control(new Date(), [
                                            Validators.required,
                                        ]),
                                        j: this.formBuilder.control(false),
                                    });
                                } else {
                                    this.disabled = false;
                                    this.form = this.formBuilder.group({
                                        bizRegNo: this.formBuilder.control({
                                            value: res['payload'].bizRegNo,
                                            disabled: true,
                                        }),
                                        masterCd: this.formBuilder.control(res['payload'].bizRegNo),
                                        supplierNm: this.formBuilder.control({
                                            value: res['payload'].supplierNm.trim(),
                                            disabled: true,
                                        }),
                                        artisanNo: this.formBuilder.control(
                                            res['payload'].artisanNo,
                                            [Validators.required]
                                        ),
                                        staffNm: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        encData: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        authListStr: this.formBuilder.control('c'),
                                        indRegNo: this.formBuilder.control(null, [
                                            Validators.required,
                                            CustomValidators.isCin(),
                                        ]),
                                        issuedYmdStr: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),

                                        staffDeptNm: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        positionNm: this.formBuilder.control(null, [
                                            Validators.required,
                                        ]),
                                        telNo: this.formBuilder.control(null, [
                                            Validators.required, CustomValidators.PhoneNumberValidator(),
                                        ]),
                                        faxNo: this.formBuilder.control(null),
                                        mtelNo: this.formBuilder.control(null),
                                        email: this.formBuilder.control(null, [
                                            Validators.required,
                                            CustomValidators.emailValidator(),
                                        ]),
                                        corporationCl: this.formBuilder.control(
                                            res['payload'].corporationCl,
                                            [Validators.required]
                                        ),
                                        chfIndRegNo: this.formBuilder.control(res['payload'].chfIndRegNo, [Validators.required]),
                                        regDt: this.formBuilder.control(new Date(), [
                                            Validators.required,
                                        ]),

                                        j: this.formBuilder.control(false),
                                    });
                                }
                            });
                    }
                });
        } else {
            this.certifAchetService
                .checkIdRegistre(this.bizRegNo)
                .subscribe((res) => {
                    if (res['payload'].success != 'N') {
                        const options = [];
                        this.certifFournisseurService
                            .checkListDroitsAch(this.bizRegNo)
                            .subscribe({
                                next: (checklist) => {
                                    if (checklist['payload'].authDuplYn == 'Y') {
                                        this.disabled = true;
                                        this.form = this.formBuilder.group({
                                            bizRegNo: this.formBuilder.control({
                                                value: res['payload'].instRegNo,
                                                disabled: true,
                                            }),
                                            masterCd: this.formBuilder.control(
                                                res['payload'].instRegNo
                                            ),
                                            supplierNm: this.formBuilder.control({
                                                value: res['payload'].instNm.trim(),
                                                disabled: true,
                                            }),

                                            staffNm: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            encData: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            authListStr: this.formBuilder.control('c'),
                                            indRegNo: this.formBuilder.control(null, [
                                                Validators.required, CustomValidators.isCin()
                                            ]),
                                            issuedYmdStr: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),

                                            staffDeptNm: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            positionNm: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            telNo: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            faxNo: this.formBuilder.control(null),
                                            mtelNo: this.formBuilder.control(null),
                                            email: this.formBuilder.control(null, [
                                                Validators.required,
                                                CustomValidators.emailValidator()
                                            ]),
                                            corporationCl: this.formBuilder.control(1, [
                                                Validators.required,
                                            ]),
                                            chfIndRegNo: this.formBuilder.control(res['payload'].chfIndRegNo, [Validators.required]),
                                            regDt: this.formBuilder.control(new Date(), [
                                                Validators.required,
                                            ]),
                                            h: this.formBuilder.control(false),
                                        });
                                    } else {
                                        this.disabled = false;
                                        this.form = this.formBuilder.group({
                                            bizRegNo: this.formBuilder.control({
                                                value: res['payload'].instRegNo,
                                                disabled: true,
                                            }),
                                            masterCd: this.formBuilder.control(
                                                res['payload'].instRegNo
                                            ),
                                            supplierNm: this.formBuilder.control({
                                                value: res['payload'].instNm.trim(),
                                                disabled: true,
                                            }),

                                            staffNm: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            encData: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            authListStr: this.formBuilder.control('c'),
                                            indRegNo: this.formBuilder.control(null, [
                                                Validators.required, CustomValidators.isCin()
                                            ]),
                                            issuedYmdStr: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),

                                            staffDeptNm: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            positionNm: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            telNo: this.formBuilder.control(null, [
                                                Validators.required,
                                            ]),
                                            faxNo: this.formBuilder.control(null),
                                            mtelNo: this.formBuilder.control(null),
                                            email: this.formBuilder.control(null, [
                                                Validators.required,
                                                CustomValidators.emailValidator()
                                            ]),
                                            corporationCl: this.formBuilder.control(1, [
                                                Validators.required,
                                            ]),
                                            chfIndRegNo: this.formBuilder.control(res['payload'].chfIndRegNo, [Validators.required]),
                                            regDt: this.formBuilder.control(new Date(), [
                                                Validators.required,
                                            ]),
                                            h: this.formBuilder.control(false),
                                        });
                                    }
                                },
                                complete: () => {
                                    this.onLoading = false;
                                }
                            });

                    }
                });
        }
    }

    ngAfterViewInit(): void {
    }

    setNewDateValue(dateValue: any, control: FormControl) {
        control.setValue('new darte value', dateValue);
        // control.setValue('control', control);
        control.setValue(dateValue);
    }

    getAll() {
        this.loginService.getCer().subscribe((res) => {
            this.certificates = res;
            this.dataSource.data = res;
        });
    }

    verifierLocal() {
        this.loginService.getInfoCer().subscribe((res) => {
            this.infooscert = res;
            if ((this.infooscert.name = 'TUNEPS Local Server')) {
                this.certiflocalbool = true;
            }
        });
    }

    verifOS() {
        var OSName = 'Windows';
        if (navigator.appVersion.indexOf('Mac') != -1) {
            OSName = 'MacOS';
        }
        if (navigator.appVersion.indexOf('X11') != -1) {
            OSName = 'UNIX';
        }
        if (navigator.appVersion.indexOf('Linux') != -1) {
            OSName = 'Linux';
        }
        if (OSName == 'Windows') {
            window.location.href = this.DOWNLOAD_URL_BASE + 'TUNEPS.exe';
        } else if ((OSName = 'Linux')) {
            window.location.href = this.DOWNLOAD_URL_BASE + 'TUNEPS-linux.sh';
        } else if (OSName == 'Mac_Os') {
            window.location.href = this.DOWNLOAD_URL_BASE + 'TUNEPS.pkg';
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {certificatees} = changes;
        if (certificatees.currentValue !== certificatees.previousValue) {
            this.loadDataSource(certificatees.currentValue);
        }
    }

    loadDataSource(certificates: Certificat[]) {
        this.dataSource.data = certificates;
    }

    openCertif(certificat) {
        this.certificatdetails.push(certificat);

        const dialogRef = this.dialog.open(CertificatDetailsComponent, {
            data: {certificatdetails: this.certificatdetails},
            disableClose: true,
            direction: this.appTranslateService.getDir(),
            width: '70vw',
        });
        dialogRef.afterClosed().subscribe((submit) => {
            this.certificatdetails = [];
            this.disabled_conn = !this.selection.isSelected;
        });
    }

    toggle() {
        this.disabled_conn = false;
    }

    onPrecedent() {
        this._location.back();
    }
}
